import {session} from 'wix-storage';

$w.onReady(function () 
{

});

export function fullWidthSlides1_mouseIn(event, $w) { }
export function fullWidthSlides1_mouseIn_1(event, $w) { }
export function fullWidthSlides1_pause(event, $w) { }


export function frontpageCategoryImage_click(event) 
{
	let selectedCategory;
	let $item = $w.at(event.context);
	
	selectedCategory = $item('#categoryIndexNumberButton').label;
	
	if (selectedCategory == '1') 
	{
		session.removeItem("filterBy");
   		session.setItem("filterBy", "massages");
	} 

	if (selectedCategory == '2') 
	{
		session.removeItem("filterBy");
   		session.setItem("filterBy", "bachelorette");
	}

	if (selectedCategory == '3') 
	{
		session.removeItem("filterBy");
   		session.setItem("filterBy", "weddings");
	}

	if (selectedCategory == '4') 
	{
		session.removeItem("filterBy");
   		session.setItem("filterBy", "groups");
	}

	if (selectedCategory == '5') 
	{
		session.removeItem("filterBy");
   		session.setItem("filterBy", "families");
	}

	if (selectedCategory == '6') 
	{
		session.removeItem("filterBy");
   		session.setItem("filterBy", "spafacilities");
	}

	if (selectedCategory == '7') 
	{
		session.removeItem("filterBy");
   		session.setItem("filterBy", "cosmetics");
	}
}
